import React, { useState, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import moment from 'moment';
import MarkerClusterer from '@google/markerclusterer';
import { Line, Scatter } from 'react-chartjs-2';
// import Chart from 'chartjs';
import Table from '../../components/Table';
import useApi from '../../api/useApi';

function Dashboard() {
  const hrsbtn = useRef(null);
  const daybtn = useRef(null);
  const weekbtn = useRef(null);
  const monthbtn = useRef(null);
  const myChart = useRef();
  const [getTimeStream, setStream] = useApi();
  const [getTimeStream2, setStream2] = useApi();
  const [recentData, setRecentData] = useApi();
  const [recentData2, setRecentData2] = useApi();
  const [locationData, setLocationData] = useApi();
  const [eventData, setEventData] = useApi();
  const [id2, setId2] = useState('');
  const [timeInterval, setTimeInterval] = useState();
  const [scatterChart, setScatterChart] = useState(false);
  const [analyticsType, setAnalyticsType] = useState('tm');
  const [eventsFlag, setEventsFlag] = useState(false);
  const [timeFlag, setTimeFlag] = useState(false);
  const [bitValue, setBitValue] = useState({
    movement: [{ x: '', y: '' }],
    open: [],
    close: [],
    shock: [],
    reboot: [],
  });
  const [prevId, setPrevId] = useState({ id: '', type: '', period: '' });
  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [coordinates, setCoordinates] = useState([]);
  const [insight, setDeviceType] = useState({
    assetId: '',
    deviceId: '',
    assetId2:'',
    deviceId2:''
  });

  const [time, setTime] = useState({
    day: '00',
    hours: '00',
    min: '00',
    sec: '00',
  });

  const [analytics, setAnalytics] = useState('temperature');
  const [analyticsTime, setAnalyticsTime] = useState(1440);
  const [gmap, setMaps] = useState(false);
  const [zoom, setZoom] = useState(11);
  const [loader, setLoader] = useState(false);
  const [analyticsStats, setAnalyticsStats] = useState([]);

  let tmLength = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  if (getTimeStream.data?.data?.binned_time) {
    const timeStreamInterval = getTimeStream.data?.data?.binned_time;
    tmLength = timeStreamInterval.map((x) => {
      const date = new Date(x);
      const month = date.getMonth() + 1;
      const day = date.getUTCDate();
      const period = `${date.getHours()}:${date.getMinutes()}-`;
      return `${period}${month}/${day}`;
    });
  }
  let tmData = [];
  if (getTimeStream.data?.data?.[analyticsType]) {
    const temp = getTimeStream.data?.data?.[analyticsType].map((x) => parseFloat(x).toFixed(2));
    tmData = temp.map((x) => {
      if (isNaN(parseFloat(x))) {
        return null;
      }
      return x;
    });
  }

  const rand = () => Math.round(Math.random() * 20 - 10);
  const yLabels = {
    2: 'movement',
    4: 'open',
    6: 'close',
    8: 'shock',
    10: 'reboot',
  };

  useEffect(() => {
    if (!scatterChart && analyticsType === 'evt') {
      setAnalyticsType('tm');
      getAnalyticsData(insight.deviceId, analyticsType);
    }
  }, [scatterChart]);

  const data = {
    datasets: [
      {
        label: 'movement',
        data: bitValue.movement,
        backgroundColor: 'black',
      },
      {
        label: 'open',
        data: bitValue.open,
        backgroundColor: 'red',
      },
      {
        label: 'close',
        data: bitValue.close,
        backgroundColor: 'blue',
      },
      {
        label: 'shock',
        data: bitValue.shock,
        backgroundColor: 'pink',
      },
      {
        label: 'reboot',
        data: bitValue.reboot,
        backgroundColor: 'grey',
      },
    ],
  };

  let _time = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  if (eventData.data !== null && eventData.data.events.timestamp.length !== 0) {
    const timeStreamInterval1 = eventData.data.events.timestamp;
    _time = timeStreamInterval1.map((x) => {
      const date = new Date(x);
      const month = date.getMonth() + 1;
      const day = date.getUTCDate();
      const period = `${date.getHours()}:${date.getMinutes()}-`;
      return `${period}${month}/${day}`;
    });
  }
  const options = {
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          // var label = data.datasets[tooltipItem.datasetIndex].label;
          let xlabelVal = new Date(tooltipItem.xLabel).toISOString().split('T');
          xlabelVal = xlabelVal[0] + ':' + xlabelVal[1].split('.')[0];
          return '(' + new Date(tooltipItem.xLabel).toISOString().split('T')[0] + ':' + new Date(tooltipItem.xLabel).toISOString().split('T')[1].split('.')[0] + ', ' + yLabels[tooltipItem.yLabel] + ')';
        }
      }
    },
    scales: {
      xAxes: [{
        ticks: {
          beginAtZero: false,
          callback(value, index, values) {
            return _time[index];
          }
        }
      }],
      yAxes: [
        {
          ticks: {
            beginAtZero: false,
            callback(value, index, values) {
              return yLabels[value];
            },
          },
        },
      ],
    },
  };

  const ctx = document.getElementById('myChart');
  const myChart2 = new Chart(ctx, {
    type: 'line',
    plugins: [
      {
        beforeDraw: (chart) => {
          const { ctx } = chart.chart;
          ctx.save();
          const xAxis = chart.scales['x-axis-0'];
          const yAxis = chart.scales['y-axis-0'];
          const dataset = chart.data.datasets[0];
          const dataset2 = chart.data.datasets[1];
          let valueFrom = null;
          let valueFromIndex = 0;
          let xFrom = null;
          let yFrom = null;
          ctx.strokeStyle = dataset.borderColor;
          let valueFrom1 = null;
          let valueFromIndex1 = 0;
          let xFrom1 = null;
          let yFrom1 = null;
          ctx.strokeStyle = dataset.borderColor;
          dataset.data.forEach((value, index) => {
            if (value !== null) {
              const x = xAxis.getPixelForTick(index);
              const y = yAxis.getPixelForValue(value);
              if (valueFrom != null) {
                ctx.lineWidth = dataset.borderWidth;
                if (index - valueFromIndex > 1) {
                  ctx.setLineDash([6, 6]);
                  ctx.strokeStyle = 'rgb(255, 99, 132';
                } else {
                  ctx.setLineDash([]);
                  ctx.strokeStyle = dataset.borderColor;
                }
                ctx.beginPath();
                ctx.moveTo(xFrom, yFrom);
                ctx.lineTo(x, y);
                ctx.stroke();
              }
              valueFrom = value;
              valueFromIndex = index;
              xFrom = x;
              yFrom = y;
            }
          });
          dataset2.data.forEach((value, index) => {
            if (value !== null) {
              const x = xAxis.getPixelForTick(index);
              const y = yAxis.getPixelForValue(value);
              if (valueFrom1 != null) {
                ctx.lineWidth = dataset2.borderWidth;
                if (index - valueFromIndex1 > 1) {
                  ctx.setLineDash([6, 6]);
                  ctx.strokeStyle = 'rgb(255, 99, 132';
                } else {
                  ctx.setLineDash([]);
                  ctx.strokeStyle = dataset2.borderColor;
                }
                ctx.beginPath();
                ctx.moveTo(xFrom1, yFrom1);
                ctx.lineTo(x, y);
                ctx.stroke();
              }
              valueFrom1 = value;
              valueFromIndex1 = index;
              xFrom1 = x;
              yFrom1 = y;
            }
          });
          ctx.restore();
        },
      },
    ],
    data: {
      labels: analyticsType && tmLength,
      datasets: [
        {
          label: '',
          fill: false,
          lineTension: 0.2,
          backgroundColor: 'transparent',
          borderCapStyle: 'butt',
          borderColor: '#00CCFF',
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 3,
          pointHitRadius: 0,
          data: getTimeStream.data?.data?.[analyticsType],
          showLine: false,
        },
        {
          label: '',
          fill: false,
          lineTension: 0.2,
          backgroundColor: 'transparent',
          borderCapStyle: 'butt',
          borderColor: 'red',
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 3,
          pointHitRadius: 0,
          data: getTimeStream2.data?.data?.[analyticsType],
          showLine: false,
        },
      ],
    },
    options: {
      animation: {
        duration: 0,
      },
      events: [],
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
          labels: {
            padding: 100,
          },
        },
      },
      legend: {
        display: false,
        labels: {
          padding: 100,
        },
      },
      scales: {
        xAxes: [
          {
            ticks: {
              display: true,
              tickWidth: '5px',
              padding: 10,
            },
            gridLines: {
              display: true,
              drawBorder: true,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              display: true,
              tickWidth: '5px',
              padding: 10,
            },
            gridLines: {
              display: true,
              drawBorder: false,
            },
          },
        ],
      },
    },
  });

  const itemsss = ['tm', 'prs', 'h', 'vbat', 'ts', 'rssi', 'prb'];

  const getTimeStreamData = (id, id2) => {
    setTimeFlag(false);
    setId2(id2);
    if (id !== prevId.id) {
      setRecentData(`/device/${id}/recentData`, 'GET');
      setRecentData2(`/device/${id2}/recentData`, 'GET');
      setLocationData(`/device/${id}/locationData?t=1440`, 'GET');
      setStream(`/device/${id}/sensorData?t=1440&type=tm`, 'GET');
      setStream2(`/device/${id2}/sensorData?t=1440&type=tm`, 'GET');
    }
    clearInterval(timeInterval);
    setTimeInterval(
      setInterval(() => {
        setRecentData(`/device/${id}/recentData`, 'GET');
        setRecentData2(`/device/${id2}/recentData`, 'GET');
      }, 60000)
    );
  };

  useEffect(() => {
    if (!eventData.isLoading && !eventData.isError && eventData.data) {
      const movement = eventData.data.events.movement.map((x, i) => {
        if (x) {
          return {
            x: new Date(moment(eventData.data.events.timestamp[i])),
            y: 2,
          };
        }
      });
      const open = eventData.data.events.open.map((x, i) => {
        if (x) {
          return {
            x: new Date(moment(eventData.data.events.timestamp[i])),
            y: 4,
          };
        }
      });
      const close = eventData.data.events.close.map((x, i) => {
        if (x) {
          return {
            x: new Date(moment(eventData.data.events.timestamp[i])),
            y: 6,
          };
        }
      });
      const shock = eventData.data.events.shock.map((x, i) => {
        if (x) {
          return {
            x: new Date(moment(eventData.data.events.timestamp[i])),
            y: 8,
          };
        }
      });
      const reboot = eventData.data.events.reboot.map((x, i) => {
        if (x) {
          return {
            x: new Date(moment(eventData.data.events.timestamp[i])),
            y: 10,
          };
        }
      });

      setBitValue({
        movement,
        open,
        close,
        shock,
        reboot,
      });
      setLoader(false);
    }
  }, [eventData.isLoading, eventData.isError, eventData.data]);

  // sensorData response
  useEffect(() => {
    if (!getTimeStream.isLoading && !getTimeStream.isError && getTimeStream.data) {
      setLoader(false);
    }
  }, [getTimeStream.isLoading, getTimeStream.isError, getTimeStream.data]);

  useEffect(() => {
    if (!recentData.isLoading && !recentData.isError && recentData.data) {
      let gs = [];
      if (recentData.data) {
        if (recentData?.data?.response?.items.indexOf('evnts') > -1) setEventsFlag(true);
        else setEventsFlag(false);
        if (recentData?.data?.response?.data?.ts) {
          let recentTimestamp = recentData?.data?.response?.data?.ts[0];
          if (recentTimestamp > 9999999999) {
            recentTimestamp /= 1000;
          }
          const timeNow = new Date().getTime() / 1000;
          let sec = Math.ceil(timeNow - recentTimestamp);
          let day = Math.floor(sec / 86400);
          day >= 1 ? (sec -= day * 86400) : (day = '00');
          let hours = Math.floor(sec / 3600);
          hours >= 1 ? (sec -= hours * 3600) : (hours = '00');
          let min = Math.floor(sec / 60);
          min >= 1 ? (sec -= min * 60) : (min = '00');
          sec < 1 ? (sec = '00') : void 0;

          min.toString().length == 1 ? (min = `0${min}`) : void 0;
          sec.toString().length == 1 ? (sec = `0${sec}`) : void 0;
          setTime({
            day,
            hours,
            min,
            sec,
          });
        }
        gs = itemsss.filter((x) => recentData?.data?.response?.items.includes(x));
        setAnalyticsStats(gs);
        setLoader(false);
      }
    }
  }, [recentData.isLoading, recentData.isError, recentData.data]);

  useEffect(() => {
    const i = 0;
    let _lat = 0;
    let _lng = 0;
    // setCoordinates([]);
    if (!locationData.isLoading && !locationData.isError && locationData.data) {
      if (locationData?.data?.response?.data?.lat && locationData?.data?.response?.data?.lng) {
        const coor = locationData?.data?.response?.data?.lat.map((x, key) => {
          return {
            lat: parseFloat(x),
            lng: parseFloat(locationData?.data?.response?.data?.lng[key]),
          };
        });
        if (coordinates !== coor) {
          // setCoordinates([]);
          _lat = parseFloat(locationData?.data?.response?.data?.lat[i]);
          _lng = parseFloat(locationData?.data?.response?.data?.lng[i]);
          setCenter({ lat: _lat, lng: _lng });
          setCoordinates(() => coor);
        }
      } else {
        setCenter({
          lat: 32.874525,
          lng: -117.2160221,
        });
        setCoordinates([]);
      }
      setTimeFlag(true);
    }
  }, [locationData.isLoading, locationData.isError, locationData.data]);

  const showMaps = (res) => {
    setScatterChart(false)
    setAnalyticsStats([]);
    setAnalytics('temperature');
    setCoordinates([]);
    setTime({
      day: '00',
      min: '00',
      hours: '00',
      sec: '00',
    });
    setDeviceType({
      assetId: '',
    deviceId: '',
    assetId2:'',
    deviceId2:''
    });
    setMaps(res);
    setLoader(res);
  };

  const deviceType = (astId, dvcId, astId2, dvcId2) => {
    getTimeStream.data = null;
    clearInterval(timeInterval);
    setAnalyticsTime(1440);
    setAnalyticsType('tm');
    setDeviceType({
      assetId: astId,
      deviceId: dvcId,
      assetId2: astId2,
      deviceId2: dvcId2,
    });
    setPrevId({ id: '', type: '', period: '' });
  };

  const getMapOptions = (maps) => {
    return {
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: true,
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
      minZoom: 1,
      maxZoom: 18,

      mapTypeControl: true,
      // mapTypeId: maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE, maps.MapTypeId.HYBRID],
      },

      zoomControl: true,
      clickableIcons: true,
    };
  };

  const handlegoogleApi = (map, maps, places) => {
    const markers = [];
    const bounds = new maps.LatLngBounds();
    places.forEach((place, idx) => {
      // const svgMarker = {
      //   path:
      //     'm12 0c-4.4183 2.3685e-15 -8 3.5817-8 8 0 1.421 0.3816 2.75 1.0312 3.906 0.1079 0.192 0.221 0.381 0.3438 0.563l6.625 11.531 6.625-11.531c0.102-0.151 0.19-0.311 0.281-0.469l0.063-0.094c0.649-1.156 1.031-2.485 1.031-3.906 0-4.4183-3.582-8-8-8zm0 4c2.209 0 4 1.7909 4 4 0 2.209-1.791 4-4 4-2.2091 0-4-1.791-4-4 0-2.2091 1.7909-4 4-4z',
      //   fillColor: 'red',
      //   fillOpacity: 1,
      //   strokeWeight: 0,
      //   rotation: 0,
      //   scale: 1,
      //   anchor: new maps.Point(15, 30),
      // };
      markers.push(
        new maps.Marker({
          position: {
            lat: parseFloat(place.lat),
            lng: parseFloat(place.lng),
          },
          icon: 'assets/img/marker.svg',
          map,
          title: `(${new Date((locationData?.data?.response?.data?.ts[idx]) * 1000).toISOString().split('T')[0]}:${new Date((locationData?.data?.response?.data?.ts[idx]) * 1000).toISOString().split('T')[1].split('.')[0]}, ${place.lat}, ${place.lng})`
        })
      );
      bounds.extend(place);
    });
    map.fitBounds(bounds);
    bounds.getCenter();

    const markerCluster = new MarkerClusterer(map, markers, {
      imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      gridSize: 20,
      minimumClusterSize: 5,
    });

    const symbolOne = {
      path: 'M -2,0 0,-2 2,0 0,2 z',
      strokeColor: '#F00',
      fillColor: '#F00',
      fillOpacity: 1,
    };

    const symbolThree = {
      path: 'M -2,-2 2,2 M 2,-2 -2,2',
      strokeColor: '#292',
      strokeWeight: 1,
    };

    const symbolTwo = {
      path: maps.SymbolPath.FORWARD_CLOSED_ARROW,
      scale: 2,
      scaledSize: new maps.Size(100, 100),
      origin: new maps.Point(0, 0), // origin
      anchor: new maps.Point(0, 0), // anchor
      strokeColor: 'red',
      rotation: 180,
    };

    const routePolyline = new maps.Polyline({
      path: places,
      icons: [
        {
          icon: symbolOne,
          offset: '0%',
        },
        {
          icon: symbolTwo,
          offset: '50%',
        },
        {
          icon: symbolThree,
          offset: '100%',
        },
      ],
      strokeColor: '#00CCFF',
      strokeWidth: 1,
      strokeWeight: 1,
    });
    routePolyline.setMap(map);
  };

  const getAnalyticsData = (deviceId, type) => {
    setLoader(true);
    if (myChart2 !== undefined) {
      while (myChart2.data.datasets.length > 0) {
        myChart2.data.datasets.pop();
      }
    }
    if (type === prevId.type && analyticsTime !== prevId.period) {
      setPrevId({ type });
      if (type === 'evt') {
        setEventData(`/device/${deviceId}/eventData?t=${analyticsTime}`, 'GET');
      } else {
        setStream(`/device/${deviceId}/sensorData?t=${analyticsTime}&type=${type}`, 'GET');
        
      }
      setLocationData(`/device/${deviceId}/locationData?t=${analyticsTime}`, 'GET')
    }
    if (type !== prevId.type && analyticsTime !== prevId.period) {
      setPrevId({ type });
      if (type === 'evt') {
        setEventData(`/device/${deviceId}/eventData?t=${analyticsTime}`, 'GET');
      } else {
        setStream(`/device/${deviceId}/sensorData?t=${analyticsTime}&type=${type}`, 'GET');
      }
      setLocationData(`/device/${deviceId}/locationData?t=${analyticsTime}`, 'GET');
    }
    clearInterval(timeInterval);
    setTimeInterval(
      setInterval(() => {
        if (type === 'evt') {
          setEventData(`/device/${deviceId}/eventData?t=${analyticsTime}`, 'GET');
        } else {
          setStream(`/device/${deviceId}/sensorData?t=${analyticsTime}&type=${type}`, 'GET');
        }
        setLocationData(`/device/${deviceId}/locationData?t=${analyticsTime}`, 'GET');
      }, 60000)
    );
  };
  useEffect(() => {
    if (gmap) {
      getAnalyticsData(insight.deviceId, analyticsType);
    }
    // action on update of movies
  }, [analyticsTime]);

  return (
    <div className="m-8 fixed bg-white"
      style={{
        left: '14%',
        right: '14%',
        width: '81%',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '6px'
        // height: '75vh'
      }}>
      <Table getTimeStreamData={getTimeStreamData} showMap={showMaps} height={gmap} deviceType={deviceType} />
      <div className="insightBar" style={{ top: gmap && '50%' }}>
        <div
          className="w-full px-5 py-2 text-white text-xs font-medium bg-primary flex justify-between"
          onDoubleClick={() => {
            if (insight.deviceId) {
              setMaps(!gmap);
            }
            setCenter({ lat: 32.874525, lng: -117.2160221 });
            setAnalytics('');
          }}
        >
          <p className="uppercase">
            {insight.assetId ? `${insight.assetId} (${insight.deviceId}) ` : ''}
          </p>
          {!analyticsStats.includes('vbat') ? (
            ''
          ) : (
            <div className="absolute flex" style={{ left: '15%' }}>
              <img src="assets/img/Battery.png" className="w-4 mr-2 transform -rotate-90" alt="" />
              {recentData?.data?.response?.data?.vbat[0]}mV
            </div>
          )}
          {!analyticsStats.includes('rssi') ? (
            ''
          ) : (
            <div className="absolute flex" style={{ left: '22%' }}>
              <img src="assets/img/Antenna.png" className="w-4 mr-2" alt="" />
              {recentData?.data?.response?.data?.rssi[0]}dBm
            </div>
          )}
         <div className="absolute flex" style={{ left: '43%' }}>
              <img src="assets/img/Battery.png" className="w-4 mr-2 transform -rotate-90" alt="" />
              {recentData2?.data?.response?.items.length !== 0 && recentData2?.data?.response?.data?.vbat !== undefined  && recentData2?.data?.response?.data?.vbat[0]}mV
            </div> 
         <div className="absolute flex" style={{ left: '51%' }}>
              <img src="assets/img/Antenna.png" className="w-4 mr-2" alt="" />
              {recentData2?.data?.response?.items.length !== 0 && recentData2?.data?.response?.data?.rssi !== undefined  && recentData2?.data?.response?.data?.rssi[0]}dBm
            </div>
           <p className="uppercase absolute" style={{left:'29%'}}>
            {id2}
          </p>
          <img
            src="assets/img/Arrow.svg"
            className={`w-3.5 mr-2 ${gmap ? `h-tableHeightMap transform rotate-90` : `h-tableHeight`}`}
            onClick={() => {
              if (insight.deviceId) {
                setMaps(!gmap);
              }
              setCenter({ lat: 32.874525, lng: -117.2160221 });
              setAnalytics('');
            }}
            alt=""
          />
        </div>

        {gmap ? (
          <div className="flex bg-white relative top-0 left-0 right-0 bottom-0" style={{ height: '92%' }}>
            <div className="w-1/2 mx-3 border-2 relative">
              {!loader &&
                !analyticsStats.includes('h') &&
                !analyticsStats.includes('tm') &&
                !analyticsStats.includes('prb') &&
                !analyticsStats.includes('prs') && (
                  <div className="absolute w-full py-3 left-10 z-50" alt="">
                    NO SENSOR DATA AVAILABLE
                  </div>
                )}
              {loader && (
                <img
                  src="assets/img/loader.svg"
                  className="absolute top-1/4 left-2/4 w-16 "
                  alt=""
                  style={{ zIndex: '19999999' }}
                />
              )}
              <div className="flex w-full absolute">
                {analyticsStats.includes('tm') && (
                  <button
                    className={`flex items-center h-10 m-1
                    text-center border-2 ${analyticsType === 'tm' ? 'bg-btnBg text-white' : ''
                      } rounded-lg focus:outline-none hover:border-indigo-400 focus-within:border-indigo-400`}
                    onClick={() => {
                      setAnalytics('temperature');
                      setAnalyticsType('tm');
                      getAnalyticsData(insight.deviceId, 'tm');
                      setScatterChart(false);
                    }}
                  >
                    {/* <span className="float-right text-md mx-2 mt-1">
                      {`${Math.floor(recentData?.data?.response?.data?.tm[0])}`}
                      &#8451;
                    </span> */}
                    <img src="assets/img/temperature.png" className="w-3 mx-1" alt="" />
                    <span className="text-xs mr-1">
                      TEMP
                    </span>
                  </button>
                )}
                {analyticsStats.includes('h') && (
                  <button
                    className={`flex items-center h-10 m-1 
                     border-2 rounded-lg ${analyticsType === 'h' ? 'bg-btnBg text-white' : ''
                      } focus:outline-none hover:border-indigo-400 focus-within:border-indigo-400`}
                    onClick={() => {
                      setAnalyticsType(() => 'h');
                      setAnalytics('humidity');
                      getAnalyticsData(insight.deviceId, 'h');
                      setScatterChart(false);
                    }}
                  >
                    {/* <span className="float-right text-md mx-2 mt-1">
                      {`${Math.floor(recentData?.data?.response?.data?.h[0])}%`}
                    </span> */}
                    <img src="assets/img/humidity.png" className="w-6 mx-1" alt="" />
                    <span className="text-xs mr-1">
                      HUM
                    </span>
                  </button>
                )}

                {analyticsStats.includes('prs') && (
                  <button
                    className={`flex items-center h-10 m-1
                    text-center border-2 ${analyticsType === 'prs' ? 'bg-btnBg text-white' : ''
                      } focus:outline-none rounded-lg hover:border-indigo-400 focus-within:border-indigo-400`}
                    onClick={() => {
                      setAnalytics('pressure');
                      setAnalyticsType('prs');
                      getAnalyticsData(insight.deviceId, 'prs');
                      setScatterChart(false);
                    }}
                  >
                    {/* <span className="float-right text-md mx-2 mt-1">
                      {`${Math.floor(recentData?.data?.response?.data?.prs[0])}`}
                    </span> */}
                    <img src="assets/img/pressure.png" className="w-6 mx-1" alt="" />
                    <span className="text-xs mr-1">
                      PRES
                    </span>
                  </button>
                )}
                {analyticsStats.includes('prb') && (
                  <button
                    className={`flex items-center h-10 m-1 text-center border-2 ${analyticsType === 'prb' ? 'bg-btnBg text-white' : ''
                      } focus:outline-none rounded-lg hover:border-indigo-400 focus-within:border-indigo-400`}
                    onClick={() => {
                      setAnalytics('cryo');
                      setAnalyticsType('prb');
                      getAnalyticsData(insight.deviceId, 'prb');
                      setScatterChart(false);
                    }}
                  >
                    {/* <span className="float-right text-md mx-2 mt-1 ">
                      {`${Math.floor(recentData?.data?.response?.data?.prb[0])}`}
                      &#8451;
                    </span> */}
                    <img src="assets/img/temperature.png" className="w-3 mx-1" alt="" />
                    <span className="text-xs mr-1">
                      PROB
                    </span>
                  </button>
                )}
                {
                  eventsFlag && timeFlag &&
                  <button
                    type="submit"
                    className={`w-16 px-2 text-xs mt-2 absolute right-0 h-8 mx-1 border-2 ${analyticsType === 'evt' ? 'border-indigo-400' : ''
                      } focus:outline-none rounded-lg hover:border-indigo-400 focus-within:border-indigo-400`}
                    onClick={() => {
                      if (analytics !== 'event') {
                        setAnalytics('events');
                        setAnalyticsType('evt');
                        getAnalyticsData(insight.deviceId, 'evt');
                      } else {
                        setAnalytics('temperature');
                        setAnalyticsType('tm');
                        getAnalyticsData(insight.deviceId, 'tm');
                      }
                      setScatterChart(!scatterChart);
                    }}
                  >
                    EVENTS
                  </button>
                }
              </div>
              {timeFlag && <div className="flex absolute top-12 right-0 mx-2 uppercase justify-between float-right">
                {/* <p className="text-role pl-2 mt-1 font-black">{analytics}</p> */}
                <div>
                  <button
                    type="submit"
                    ref={hrsbtn}
                    className={`w-6 text-xs h-5 border-r-2 ${analyticsTime === 180 ? 'bg-btnBg text-white' : ''
                      } focus:outline-none`}
                    onClick={() => {
                      setZoom(14);
                      setAnalyticsTime(180);
                    }}
                  >
                    3H
                  </button>
                  <button
                    ref={daybtn}
                    type="submit"
                    className={`w-6 text-xs h-5 border-r-2 ${analyticsTime === 1440 ? 'bg-btnBg text-white' : ''
                      } focus:outline-none`}
                    onClick={() => {
                      setZoom(11);
                      setAnalyticsTime(1440);
                    }}
                  >
                    1D
                  </button>
                  <button
                    ref={weekbtn}
                    type="submit"
                    className={`w-6 text-xs h-5 border-r-2 ${analyticsTime === 10080 ? 'bg-btnBg text-white' : ''
                      } focus:outline-none`}
                    onClick={() => {
                      setZoom(6)
                      setAnalyticsTime(10080);
                    }}
                  >
                    1W
                  </button>
                  <button
                    ref={monthbtn}
                    type="submit"
                    className={`w-6 text-xs h-5 ${analyticsTime === 43200 ? 'bg-btnBg text-white' : ''
                      } focus:outline-none hover:border-indigo-400`}
                    onClick={() => {
                      setZoom(0);
                      setAnalyticsTime(43200);
                    }}
                  >
                    1M
                  </button>
                </div>
              </div>
              }

              <div className="h-full w-full px-3 absolute top-1/4">
                <div className="h-3/4 absolute left-0 right-0">

                  <div style={{ height: '100%', width: '100%' }}>
                    {!scatterChart && <canvas id="myChart" ref={myChart} />}
                    {scatterChart && <Scatter data={data} options={options} />}
                  </div>
                  {/* <Line data={data} options={options} /> */}
                </div>
              </div>
            </div>
            <div className="w-1/2 mr-2">
              <GoogleMapReact
                key={coordinates}
                bootstrapURLKeys={{ key: 'AIzaSyDVsc9GqAbD6BF7vKPaLTNgtFFksrxj0Yw' }}
                options={getMapOptions}
                defaultZoom={11}
                center={center}
                onGoogleApiLoaded={({ map, maps }) => handlegoogleApi(map, maps, coordinates)}
                yesIWantToUseGoogleMapApiInternals
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Dashboard;
